// extracted by mini-css-extract-plugin
export default {"runningShoeSpinner":"RunningShoesSpinner_runningShoeSpinner__x2O44","spin":"RunningShoesSpinner_spin__Fo-mw"};